module.exports = __webpack_public_path__ + "static/feyi-3b34c8dfd57b9220ada7a2593e54d6ce.png";